export interface ActiveFilterTag {
  label: string;
  value?: string;
  values?: string[];
  displayName: string;
  field: string;
  isSaved?: boolean;
}
